import React, { useEffect, useState, useRef } from 'react';
import { Building2, Users, HandshakeIcon, TrendingUp, Calendar, Euro, Mail, Eye, X, ChevronDown, MapPin, Target, BarChart3, LayoutGrid, Sparkles, Send, Loader2, Plus, Clock, CheckCircle2, Circle, ArrowRight, Store, Menu, FileText } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { motion, AnimatePresence } from 'framer-motion';
import { StatsWidget } from '../components/widgets/StatsWidget';
import { ChartWidget } from '../components/widgets/ChartWidget';
import { ActivityWidget } from '../components/widgets/ActivityWidget';
import { CampaignWidget } from '../components/widgets/CampaignWidget';
import { PerformanceWidget } from '../components/widgets/PerformanceWidget';
import { AIAssistantWidget } from '../components/widgets/AIAssistantWidget';
import { ReportPreview } from '../components/ReportPreview';
const stats = [{
  id: 'stat-1',
  icon: Building2,
  label: 'Immobili Attivi',
  value: '48',
  change: '+12%',
  trend: 'up'
}, {
  id: 'stat-2',
  icon: Users,
  label: 'Brand nel CRM',
  value: '127',
  change: '+8%',
  trend: 'up'
}, {
  id: 'stat-3',
  icon: HandshakeIcon,
  label: 'Trattative in Corso',
  value: '23',
  change: '+15%',
  trend: 'up'
}, {
  id: 'stat-4',
  icon: TrendingUp,
  label: 'Tasso di Conversione',
  value: '34%',
  change: '+5%',
  trend: 'up'
}];
const monthlyData = [{
  month: 'Gen',
  deals: 12,
  revenue: 850000,
  dealsRetail: 8,
  dealsInvestment: 4,
  revenueRetail: 600000,
  revenueInvestment: 250000
}, {
  month: 'Feb',
  deals: 15,
  revenue: 1200000,
  dealsRetail: 10,
  dealsInvestment: 5,
  revenueRetail: 820000,
  revenueInvestment: 380000
}, {
  month: 'Mar',
  deals: 18,
  revenue: 1450000,
  dealsRetail: 12,
  dealsInvestment: 6,
  revenueRetail: 980000,
  revenueInvestment: 470000
}, {
  month: 'Apr',
  deals: 14,
  revenue: 980000,
  dealsRetail: 9,
  dealsInvestment: 5,
  revenueRetail: 650000,
  revenueInvestment: 330000
}, {
  month: 'Mag',
  deals: 20,
  revenue: 1650000,
  dealsRetail: 14,
  dealsInvestment: 6,
  revenueRetail: 1100000,
  revenueInvestment: 550000
}, {
  month: 'Giu',
  deals: 23,
  revenue: 1890000,
  dealsRetail: 15,
  dealsInvestment: 8,
  revenueRetail: 1250000,
  revenueInvestment: 640000
}];
const pipelinePhases = [{
  phase: 'Lead',
  deals: 12,
  value: 450000,
  color: '#e5e7eb'
}, {
  phase: 'Qualificazione',
  deals: 8,
  value: 680000,
  color: '#d1d5db'
}, {
  phase: 'Proposta',
  deals: 6,
  value: 920000,
  color: '#9ca3af'
}, {
  phase: 'Negoziazione',
  deals: 4,
  value: 780000,
  color: '#6b7280'
}, {
  phase: 'Contratto',
  deals: 3,
  value: 1200000,
  color: '#4b5563'
}, {
  phase: 'Chiuso',
  deals: 2,
  value: 850000,
  color: '#1388ad'
}];
const recentActivities = [{
  id: 1,
  type: 'deal',
  title: 'Nuova trattativa avviata',
  description: 'Via Montenapoleone 12 - Luxury Fashion Brand',
  time: '2 ore fa',
  status: 'success'
}, {
  id: 2,
  type: 'property',
  title: 'Immobile aggiunto',
  description: 'Corso Buenos Aires 45 - 150m² Retail',
  time: '5 ore fa',
  status: 'info'
}, {
  id: 3,
  type: 'email',
  title: 'Campagna email inviata',
  description: 'Nuovi Immobili Retail - 45 destinatari',
  time: '1 giorno fa',
  status: 'success'
}, {
  id: 4,
  type: 'brand',
  title: 'Nuovo brand registrato',
  description: 'Premium Lifestyle Co. - Fashion',
  time: '2 giorni fa',
  status: 'info'
}];
const availableWidgets = [{
  id: 'ai-assistant',
  label: 'AI Assistant',
  category: 'Strumenti'
}, {
  id: 'stat-1',
  label: 'Immobili Attivi',
  category: 'Statistiche'
}, {
  id: 'stat-2',
  label: 'Brand nel CRM',
  category: 'Statistiche'
}, {
  id: 'stat-3',
  label: 'Trattative in Corso',
  category: 'Statistiche'
}, {
  id: 'stat-4',
  label: 'Tasso di Conversione',
  category: 'Statistiche'
}, {
  id: 'chart-deals',
  label: 'Andamento Mensile',
  category: 'Grafici'
}, {
  id: 'campaigns',
  label: 'Campagne Email',
  category: 'Marketing'
}, {
  id: 'activities',
  label: 'Attività Recenti',
  category: 'Attività'
}, {
  id: 'performance',
  label: 'Performance Mensile',
  category: 'Statistiche'
}];
const statsCategories = {
  brands: [{
    icon: Users,
    label: 'Brand Totali',
    value: '127',
    change: '+8%',
    trend: 'up'
  }, {
    icon: Target,
    label: 'Brand Attivi',
    value: '89',
    change: '+12%',
    trend: 'up'
  }, {
    icon: TrendingUp,
    label: 'Nuovi Questo Mese',
    value: '15',
    change: '+25%',
    trend: 'up'
  }, {
    icon: BarChart3,
    label: 'Tasso Conversione',
    value: '34%',
    change: '+5%',
    trend: 'up'
  }, {
    icon: Euro,
    label: 'Budget Medio',
    value: '€650K',
    change: '+8%',
    trend: 'up'
  }],
  immobili: [{
    icon: Building2,
    label: 'Immobili Attivi',
    value: '48',
    change: '+12%',
    trend: 'up'
  }, {
    icon: Eye,
    label: 'Disponibili',
    value: '32',
    change: '+8%',
    trend: 'up'
  }, {
    icon: HandshakeIcon,
    label: 'In Trattativa',
    value: '16',
    change: '+15%',
    trend: 'up'
  }, {
    icon: LayoutGrid,
    label: 'Superficie Totale',
    value: '8.5K m²',
    change: '+10%',
    trend: 'up'
  }, {
    icon: Euro,
    label: 'Valore Portfolio',
    value: '€42M',
    change: '+18%',
    trend: 'up'
  }],
  trattative: {
    retail: [{
      icon: HandshakeIcon,
      label: 'Trattative Retail',
      value: '15',
      change: '+18%',
      trend: 'up'
    }, {
      icon: Euro,
      label: 'Revenue Retail',
      value: '€1.25M',
      change: '+15%',
      trend: 'up'
    }, {
      icon: TrendingUp,
      label: 'Conversion Rate Retail',
      value: '38%',
      change: '+6%',
      trend: 'up'
    }],
    investment: [{
      icon: HandshakeIcon,
      label: 'Trattative Investment',
      value: '8',
      change: '+12%',
      trend: 'up'
    }, {
      icon: Euro,
      label: 'Revenue Investment',
      value: '€640K',
      change: '+10%',
      trend: 'up'
    }, {
      icon: TrendingUp,
      label: 'Conversion Rate Investment',
      value: '28%',
      change: '+4%',
      trend: 'up'
    }]
  }
};
const dealsData = [{
  month: 'Gen',
  trattative: 12,
  chiuse: 8,
  valore: 850000
}, {
  month: 'Feb',
  trattative: 15,
  chiuse: 10,
  valore: 1200000
}, {
  month: 'Mar',
  trattative: 18,
  chiuse: 12,
  valore: 1450000
}, {
  month: 'Apr',
  trattative: 14,
  chiuse: 9,
  valore: 980000
}, {
  month: 'Mag',
  trattative: 20,
  chiuse: 14,
  valore: 1650000
}, {
  month: 'Giu',
  trattative: 23,
  chiuse: 16,
  valore: 1890000
}];
const propertyTypeData = [{
  name: 'Retail',
  value: 48,
  color: '#1388ad'
}, {
  name: 'Showroom',
  value: 32,
  color: '#3d9dbd'
}, {
  name: 'Boutique',
  value: 28,
  color: '#6bb2cd'
}, {
  name: 'Flagship Store',
  value: 22,
  color: '#99c7dd'
}, {
  name: 'Concept Store',
  value: 18,
  color: '#0f6b8a'
}, {
  name: 'Pop-up Store',
  value: 15,
  color: '#2a8aa8'
}, {
  name: 'Uffici',
  value: 15,
  color: '#c7dce8'
}, {
  name: 'Ristorante',
  value: 14,
  color: '#1388ad'
}, {
  name: 'Caffetteria',
  value: 12,
  color: '#3d9dbd'
}, {
  name: 'Galleria Arte',
  value: 11,
  color: '#6bb2cd'
}, {
  name: 'Atelier',
  value: 10,
  color: '#99c7dd'
}, {
  name: 'Coworking',
  value: 9,
  color: '#0f6b8a'
}, {
  name: 'Palestra',
  value: 8,
  color: '#2a8aa8'
}, {
  name: 'Spa/Benessere',
  value: 7,
  color: '#c7dce8'
}, {
  name: 'Laboratorio',
  value: 6,
  color: '#1388ad'
}, {
  name: 'Negozio Alimentare',
  value: 5,
  color: '#3d9dbd'
}];
const brandCategoryData = [{
  category: 'Fashion',
  count: 45,
  budget: 850000,
  color: '#1388ad'
}, {
  category: 'Lifestyle',
  count: 32,
  budget: 720000,
  color: '#3d9dbd'
}, {
  category: 'Design',
  count: 28,
  budget: 650000,
  color: '#6bb2cd'
}, {
  category: 'Luxury',
  count: 25,
  budget: 920000,
  color: '#99c7dd'
}, {
  category: 'Gioielli',
  count: 22,
  budget: 880000,
  color: '#0f6b8a'
}, {
  category: 'Food',
  count: 22,
  budget: 480000,
  color: '#2a8aa8'
}, {
  category: 'Arredamento',
  count: 18,
  budget: 750000,
  color: '#c7dce8'
}, {
  category: 'Arte',
  count: 15,
  budget: 680000,
  color: '#1388ad'
}, {
  category: 'Accessori',
  count: 12,
  budget: 520000,
  color: '#3d9dbd'
}];
const brandLocationData = [{
  name: 'Quadrilatero',
  value: 38,
  color: '#1388ad'
}, {
  name: 'Brera',
  value: 25,
  color: '#3d9dbd'
}, {
  name: 'Corso Como',
  value: 22,
  color: '#6bb2cd'
}, {
  name: 'Tortona',
  value: 18,
  color: '#99c7dd'
}, {
  name: 'Altri',
  value: 24,
  color: '#c7dce8'
}];
const brandAcquisitionData = [{
  month: 'Gen',
  nuovi: 8,
  attivi: 102
}, {
  month: 'Feb',
  nuovi: 12,
  attivi: 108
}, {
  month: 'Mar',
  nuovi: 15,
  attivi: 115
}, {
  month: 'Apr',
  nuovi: 10,
  attivi: 118
}, {
  month: 'Mag',
  nuovi: 18,
  attivi: 122
}, {
  month: 'Giu',
  nuovi: 15,
  attivi: 127
}];
const topBrandsByBudget = [{
  name: 'Luxury Watches & Jewelry',
  category: 'Gioielli',
  budget: '€1.5M',
  location: 'Montenapoleone',
  status: 'Attivo'
}, {
  name: 'Premium Lifestyle Co.',
  category: 'Lifestyle',
  budget: '€1.5M',
  location: 'Quadrilatero',
  status: 'Attivo'
}, {
  name: 'Furniture Luxury',
  category: 'Arredamento',
  budget: '€1.3M',
  location: 'Tortona',
  status: 'Attivo'
}, {
  name: 'Elite Fashion Group',
  category: 'Fashion',
  budget: '€1.2M',
  location: 'Via della Spiga',
  status: 'Attivo'
}, {
  name: 'Premium Design House',
  category: 'Design',
  budget: '€1.1M',
  location: 'Porta Nuova',
  status: 'Attivo'
}];
const brandEngagementData = [{
  category: 'Fashion',
  tassoRisposta: 78,
  tassoConversione: 42
}, {
  category: 'Lifestyle',
  tassoRisposta: 85,
  tassoConversione: 38
}, {
  category: 'Design',
  tassoRisposta: 72,
  tassoConversione: 35
}, {
  category: 'Gioielli',
  tassoRisposta: 90,
  tassoConversione: 45
}];
const todayActivities = [{
  id: '1',
  title: 'Preparare presentazione per Luxury Fashion Brand',
  completed: false,
  dueTime: '10:00',
  priority: 'high'
}, {
  id: '2',
  title: 'Inviare contratto a Jewelry Excellence',
  completed: false,
  dueTime: '14:00',
  priority: 'high'
}, {
  id: '3',
  title: 'Follow-up con Premium Lifestyle Co.',
  completed: true,
  dueTime: '09:00',
  priority: 'medium'
}, {
  id: '4',
  title: 'Aggiornare CRM con nuovi contatti',
  completed: false,
  dueTime: '16:00',
  priority: 'medium'
}];
const todayEvents = [{
  id: '1',
  title: 'Sopralluogo Via Montenapoleone',
  time: '10:00 - 11:30',
  type: 'visit',
  location: 'Via Montenapoleone 12',
  color: '#8b5cf6'
}, {
  id: '2',
  title: 'Call con Premium Lifestyle Co.',
  time: '14:00 - 15:00',
  type: 'call',
  attendees: 'Giuseppe Verdi',
  color: '#3b82f6'
}];
interface GeneratedWidget {
  id: string;
  type: 'chart' | 'stat' | 'table' | 'report';
  title: string;
  data: any;
  timestamp: Date;
}
interface AIMessage {
  role: 'user' | 'assistant';
  content: string;
  widgetIds?: string[];
  isDemo?: boolean;
}
interface ChatHistory {
  id: string;
  title: string;
  messages: AIMessage[];
  widgets: GeneratedWidget[];
  timestamp: Date;
}
export function Dashboard() {
  const [dateRange, setDateRange] = useState('Ultimi 30 giorni');
  const [activeTab, setActiveTab] = useState<'overview' | 'brands' | 'immobili' | 'trattative'>('overview');
  const [dealTypeFilter, setDealTypeFilter] = useState<'all' | 'retail' | 'investment'>('all');
  const [isAIMode, setIsAIMode] = useState(false);
  const [aiMessages, setAiMessages] = useState<AIMessage[]>([]);
  const [aiInput, setAiInput] = useState('');
  const [isAILoading, setIsAILoading] = useState(false);
  const [generatedWidgets, setGeneratedWidgets] = useState<GeneratedWidget[]>([]);
  const [widgetFilter, setWidgetFilter] = useState('all');
  const [widgetPeriod, setWidgetPeriod] = useState('30d');
  const [mobileAIView, setMobileAIView] = useState<'chat' | 'widgets'>('chat');
  const [activities, setActivities] = useState(todayActivities);
  const [isTrattativeFilterOpen, setIsTrattativeFilterOpen] = useState(false);
  const [hasStartedChat, setHasStartedChat] = useState(false);
  const [isChatHistoryOpen, setIsChatHistoryOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState<ChatHistory[]>([]);
  const [currentChatId, setCurrentChatId] = useState<string | null>(null);
  const [showReportPreview, setShowReportPreview] = useState(false);
  const [currentReport, setCurrentReport] = useState<any>(null);
  const trattativeFilterRef = useRef<HTMLDivElement>(null);
  const tabs = [{
    id: 'overview' as const,
    label: 'Overview',
    icon: LayoutGrid
  }, {
    id: 'brands' as const,
    label: 'Brands',
    icon: Users
  }, {
    id: 'immobili' as const,
    label: 'Immobili',
    icon: Building2
  }, {
    id: 'trattative' as const,
    label: 'Trattative',
    icon: HandshakeIcon
  }];
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (trattativeFilterRef.current && !trattativeFilterRef.current.contains(event.target as Node)) {
        setIsTrattativeFilterOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const toggleActivity = (id: string) => {
    setActivities(activities.map(activity => activity.id === id ? {
      ...activity,
      completed: !activity.completed
    } : activity));
  };
  const handleAISubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!aiInput.trim() || isAILoading) return;
    if (!hasStartedChat) {
      setHasStartedChat(true);
      if (!currentChatId) {
        const newChatId = `chat-${Date.now()}`;
        setCurrentChatId(newChatId);
      }
    }
    // Check if this is a report request BEFORE sending to AI
    const isReportRequest = aiInput.toLowerCase().includes('report') || aiInput.toLowerCase().includes('genera un report') || aiInput.toLowerCase().includes('crea un report') || aiInput.toLowerCase().includes('fare un report');
    // Check if this is the specific deals trend request
    const isDealsLineChartRequest = aiInput.toLowerCase().includes('andamento delle trattative') || aiInput.toLowerCase().includes('andamento trattative');
    const userMessage: AIMessage = {
      role: 'user' as const,
      content: aiInput
    };
    setAiMessages(prev => [...prev, userMessage]);
    const currentInput = aiInput;
    setAiInput('');
    setIsAILoading(true);
    // Minimum delay to simulate AI "thinking/writing" - between 1-2 seconds
    const minDelay = 1000 + Math.random() * 1000;
    // If it's the deals line chart request, generate widget immediately
    if (isDealsLineChartRequest) {
      // Add artificial delay to simulate thinking
      await new Promise(resolve => setTimeout(resolve, minDelay));
      const widgetId = `widget-${Date.now()}`;
      const newWidget: GeneratedWidget = {
        id: widgetId,
        type: 'chart',
        title: 'Andamento Trattative Mensili',
        data: {
          type: 'line',
          data: monthlyData
        },
        timestamp: new Date()
      };
      setGeneratedWidgets(prev => [...prev, newWidget]);
      const assistantMessage: AIMessage = {
        role: 'assistant' as const,
        content: `<h3>📊 Andamento Trattative Negli Ultimi Mesi</h3>
<p style="margin: 12px 0;">Ecco l'analisi dell'andamento delle trattative da Gennaio a Giugno 2024:</p>
<div style="background: #f0f9ff; border-left: 4px solid #1388ad; padding: 12px; margin: 16px 0; border-radius: 4px;">
<strong>📈 Metriche Principali</strong>
<ul style="margin: 8px 0; padding-left: 20px;">
<li>Trattative totali nel periodo: <strong>102</strong></li>
<li>Media mensile: <strong>17 trattative</strong></li>
<li>Mese migliore: <strong>Giugno</strong> con 23 trattative (+15% vs mese precedente)</li>
<li>Revenue totale: <strong>€8.02M</strong></li>
</ul>
</div>
<h4>🎯 Trend e Insights</h4>
<ul style="margin: 12px 0; padding-left: 20px;">
<li><strong>Crescita costante:</strong> Le trattative mostrano un trend positivo con una crescita media del 12% mese su mese</li>
<li><strong>Picco a Giugno:</strong> Il mese di Giugno ha registrato il numero più alto di trattative (23) e la revenue più alta (€1.89M)</li>
<li><strong>Stabilità:</strong> Anche nei mesi più deboli (Gennaio e Aprile), le trattative sono rimaste sopra le 12 unità</li>
</ul>
<h4>💡 Raccomandazioni</h4>
<ul style="margin: 12px 0; padding-left: 20px;">
<li>Analizzare i fattori che hanno portato al successo di Giugno per replicarli nei prossimi mesi</li>
<li>Mantenere il focus sulle strategie che hanno generato la crescita costante</li>
<li>Considerare di aumentare gli sforzi di prospecting per capitalizzare sul trend positivo</li>
</ul>`,
        widgetIds: [widgetId],
        isDemo: true
      };
      const updatedMessages = [...aiMessages, userMessage, assistantMessage];
      setAiMessages(updatedMessages);
      if (currentChatId) {
        const chatTitle = updatedMessages[0]?.content.slice(0, 50) + '...' || 'Nuova Chat';
        setChatHistory(prev => {
          const existingIndex = prev.findIndex(chat => chat.id === currentChatId);
          const updatedChat: ChatHistory = {
            id: currentChatId,
            title: chatTitle,
            messages: updatedMessages,
            widgets: [newWidget],
            timestamp: new Date()
          };
          if (existingIndex >= 0) {
            const newHistory = [...prev];
            newHistory[existingIndex] = updatedChat;
            return newHistory;
          }
          return [updatedChat, ...prev];
        });
      }
      setIsAILoading(false);
      return;
    }
    // If it's a report request, generate report data but DON'T open it
    if (isReportRequest) {
      // Add artificial delay to simulate thinking
      await new Promise(resolve => setTimeout(resolve, minDelay));
      let reportData: any = {
        title: 'Report Performance',
        summary: 'Questo report fornisce una panoramica completa delle performance, includendo analisi dettagliate e metriche chiave.',
        kpis: [{
          label: 'Trattative Totali',
          value: '23',
          change: '+15%'
        }, {
          label: 'Revenue Generata',
          value: '€1.89M',
          change: '+18%'
        }, {
          label: 'Brand Attivi',
          value: '127',
          change: '+8%'
        }, {
          label: 'Tasso Conversione',
          value: '34%',
          change: '+5%'
        }],
        charts: [{
          title: 'Andamento Mensile Trattative',
          type: 'line',
          xKey: 'month',
          data: monthlyData,
          lines: [{
            key: 'deals',
            name: 'Trattative',
            color: '#1388ad'
          }, {
            key: 'revenue',
            name: 'Revenue',
            color: '#10b981'
          }]
        }, {
          title: 'Distribuzione Brand per Categoria',
          type: 'pie',
          data: brandCategoryData.slice(0, 5).map(item => ({
            name: item.category,
            value: item.count,
            color: item.color
          }))
        }],
        tables: [{
          title: 'Top 5 Brand per Budget',
          headers: ['Brand', 'Categoria', 'Budget', 'Status'],
          rows: topBrandsByBudget.slice(0, 5).map(brand => [brand.name, brand.category, brand.budget, brand.status])
        }],
        insights: ['Le trattative sono cresciute del 15% rispetto al mese precedente, indicando un trend positivo.', 'Il segmento Gioielli mostra il miglior tasso di conversione (45%), suggerendo di focalizzare gli sforzi su questa categoria.', 'La revenue totale ha raggiunto €1.89M, superando gli obiettivi mensili del 12%.']
      };
      // Customize report based on request content
      if (currentInput.toLowerCase().includes('email') || currentInput.toLowerCase().includes('campagn')) {
        reportData = {
          title: 'Report Performance Campagne Email',
          summary: 'Questo report analizza le performance delle campagne email nel settore immobiliare retail, includendo tassi di apertura, clic e conversione.',
          kpis: [{
            label: 'Campagne Inviate',
            value: '45',
            change: '+22%'
          }, {
            label: 'Tasso Apertura',
            value: '68%',
            change: '+12%'
          }, {
            label: 'Tasso Clic',
            value: '24%',
            change: '+8%'
          }, {
            label: 'Conversioni',
            value: '156',
            change: '+35%'
          }],
          charts: [{
            title: 'Performance Mensile Campagne',
            type: 'line',
            xKey: 'month',
            data: [{
              month: 'Gen',
              aperture: 62,
              clic: 18,
              conversioni: 12
            }, {
              month: 'Feb',
              aperture: 65,
              clic: 20,
              conversioni: 15
            }, {
              month: 'Mar',
              aperture: 68,
              clic: 22,
              conversioni: 18
            }, {
              month: 'Apr',
              aperture: 64,
              clic: 19,
              conversioni: 14
            }, {
              month: 'Mag',
              aperture: 70,
              clic: 25,
              conversioni: 22
            }, {
              month: 'Giu',
              aperture: 68,
              clic: 24,
              conversioni: 20
            }],
            lines: [{
              key: 'aperture',
              name: 'Tasso Apertura %',
              color: '#1388ad'
            }, {
              key: 'clic',
              name: 'Tasso Clic %',
              color: '#10b981'
            }, {
              key: 'conversioni',
              name: 'Conversioni %',
              color: '#f59e0b'
            }]
          }, {
            title: 'Distribuzione Campagne per Categoria',
            type: 'pie',
            data: [{
              name: 'Nuovi Immobili',
              value: 35,
              color: '#1388ad'
            }, {
              name: 'Offerte Speciali',
              value: 25,
              color: '#10b981'
            }, {
              name: 'Newsletter',
              value: 20,
              color: '#f59e0b'
            }, {
              name: 'Follow-up',
              value: 15,
              color: '#8b5cf6'
            }, {
              name: 'Eventi',
              value: 5,
              color: '#ec4899'
            }]
          }],
          tables: [{
            title: 'Top 5 Campagne per Performance',
            headers: ['Campagna', 'Destinatari', 'Aperture', 'Clic', 'Conversioni'],
            rows: [['Nuovi Retail Quadrilatero', '450', '72%', '28%', '18'], ['Offerta Speciale Brera', '380', '68%', '25%', '15'], ['Newsletter Marzo', '820', '65%', '22%', '28'], ['Follow-up Luxury Brands', '220', '75%', '32%', '12'], ['Evento Inaugurazione', '150', '82%', '38%', '8']]
          }],
          insights: ['Le campagne su nuovi immobili nel Quadrilatero hanno il tasso di apertura più alto (72%), indicando forte interesse per questa zona.', 'Il tasso di conversione medio è del 24%, superiore del 35% rispetto al trimestre precedente.', 'Le campagne di follow-up personalizzate mostrano tassi di engagement superiori del 40% rispetto alle newsletter generiche.', 'Gli invii del martedì mattina ottengono risultati migliori del 18% rispetto ad altri giorni della settimana.']
        };
      }
      setCurrentReport(reportData);
      // DO NOT open preview automatically - removed the setTimeout
    }
    try {
      const dataContext = `
Contesto dati disponibili:
- Immobili Attivi: 48 (+12%)
- Brand nel CRM: 127 (+8%)
- Trattative in Corso: 23 (+15%)
- Tasso di Conversione: 34% (+5%)
Dati mensili (Gen-Giu):
${JSON.stringify(monthlyData, null, 2)}
Distribuzione immobili per tipologia:
${JSON.stringify(propertyTypeData, null, 2)}
Brand per categoria:
${JSON.stringify(brandCategoryData, null, 2)}
Statistiche dettagliate disponibili per:
- Brands: ${JSON.stringify(statsCategories.brands, null, 2)}
- Immobili: ${JSON.stringify(statsCategories.immobili, null, 2)}
- Trattative: ${JSON.stringify(statsCategories.trattative, null, 2)}
`;
      const startTime = Date.now();
      const response = await fetch('https://requests.magicpatterns.com/openai/proxy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'gpt-4-turbo',
          messages: [{
            role: 'system',
            content: `Sei un assistente AI esperto in real estate, business intelligence e strategia commerciale per il settore immobiliare retail.
MODALITÀ DEMO - REGOLA FONDAMENTALE:
Stai lavorando in modalità DEMO. NON dire MAI frasi come "Attualmente non dispongo di dati specifici" o "Non ho accesso ai dati reali".
INVECE, genera SEMPRE dati dimostrativi realistici e completi per mostrare le capacità del sistema.
Ogni risposta DEVE includere dati concreti, numeri, analisi e visualizzazioni anche se sono dati demo.
GENERAZIONE REPORT:
Quando l'utente chiede di "generare un report", "creare un report", o "fare un report":
1. Conferma brevemente che stai generando il report
2. Spiega che l'anteprima del report si aprirà automaticamente
3. Il sistema mostrerà un report professionale con logo Edares, grafici e possibilità di download PDF
CAPACITÀ PRINCIPALI:
1. Generazione Widget: Quando richiesto, genera visualizzazioni dati usando i tag [WIDGET:tipo]
2. Analisi Strategica: Fornisci interpretazioni approfondite dei dati, identifica trend, opportunità e rischi
3. Suggerimenti Operativi: Proponi azioni concrete basate sui dati
4. Consulenza Business: Aiuta a ottimizzare performance, conversioni e strategie di marketing
TIPI DI WIDGET DISPONIBILI:
- [WIDGET:PIE_CHART] - Grafici a torta per distribuzioni
- [WIDGET:BAR_CHART] - Grafici a barre per confronti
- [WIDGET:LINE_CHART] - Grafici a linea per trend temporali
- [WIDGET:STATS] - Card con statistiche chiave
FORMATTAZIONE OBBLIGATORIA DELLE RISPOSTE:
Le tue risposte DEVONO SEMPRE essere strutturate in HTML con:
1. **Titoli e Sezioni**: Usa <h3> per titoli principali e <h4> per sottotitoli
2. **Liste**: Usa <ul> e <ol> per elenchi puntati e numerati
3. **Tabelle**: Per dati comparativi usa sempre tabelle HTML con stili inline
4. **Enfasi**: Usa <strong> per evidenziare punti chiave
5. **Paragrafi**: Usa <p style="margin: 12px 0;"> per separare i concetti
6. **Divisori**: Usa <div> con stili per box informativi
7. **Icone testuali**: Usa emoji per rendere più visuale (📊 📈 💡 ⚠️ ✅ 🎯)
ESEMPIO DI RISPOSTA CORRETTA (sempre con dati concreti):
<h3>📊 Analisi Performance Campagne Email</h3>
<p style="margin: 12px 0;">Ecco l'analisi completa delle performance delle tue campagne email negli ultimi 6 mesi:</p>
<div style="background: #f0f9ff; border-left: 4px solid #1388ad; padding: 12px; margin: 16px 0; border-radius: 4px;">
<strong>📈 Metriche Principali</strong>
<ul style="margin: 8px 0; padding-left: 20px;">
<li>Tasso di apertura medio: <strong>68%</strong> (+12% vs trimestre precedente)</li>
<li>Tasso di click: <strong>24%</strong> (+8% vs trimestre precedente)</li>
<li>Conversioni generate: <strong>156</strong> (+35% vs trimestre precedente)</li>
</ul>
</div>
<h4>🎯 Top 3 Campagne per Performance</h4>
<table style="width: 100%; border-collapse: collapse; margin: 12px 0;">
<tr style="background: #f3f4f6;">
<th style="padding: 8px; text-align: left; border: 1px solid #e5e7eb;">Campagna</th>
<th style="padding: 8px; text-align: left; border: 1px solid #e5e7eb;">Aperture</th>
<th style="padding: 8px; text-align: left; border: 1px solid #e5e7eb;">Click</th>
</tr>
<tr>
<td style="padding: 8px; border: 1px solid #e5e7eb;">Nuovi Retail Quadrilatero</td>
<td style="padding: 8px; border: 1px solid #e5e7eb;"><strong>72%</strong></td>
<td style="padding: 8px; border: 1px solid #e5e7eb;"><strong>28%</strong></td>
</tr>
</table>
REGOLE IMPORTANTI:
- NON usare mai markdown (**, ##, etc.) - USA SOLO HTML
- SEMPRE includere tabelle per dati numerici o comparativi
- SEMPRE strutturare con titoli, liste e paragrafi
- SEMPRE usare colori e stili inline per formattazione
- SEMPRE generare dati demo completi e realistici
- Mantieni un tono professionale ma accessibile
- Per richieste di report, rispondi in modo MOLTO BREVE confermando che il report si sta aprendo
${dataContext}`
          }, ...aiMessages.map(m => ({
            role: m.role,
            content: m.content
          })), {
            role: 'user',
            content: currentInput
          }],
          temperature: 0.7,
          max_tokens: isReportRequest ? 150 : 1200
        })
      });
      const data = await response.json();
      // Calculate elapsed time and ensure minimum delay
      const elapsedTime = Date.now() - startTime;
      const remainingDelay = Math.max(0, minDelay - elapsedTime);
      // Wait for remaining delay if needed
      if (remainingDelay > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingDelay));
      }
      const assistantContent = data.choices[0].message.content;
      const newWidgetIds: string[] = [];
      if (currentInput.toLowerCase().includes('grafico') || currentInput.toLowerCase().includes('mostra') || currentInput.toLowerCase().includes('visualizza') || currentInput.toLowerCase().includes('crea un')) {
        const widgetId = `widget-${Date.now()}`;
        let widgetType: 'chart' | 'stat' | 'table' = 'chart';
        let widgetTitle = 'Analisi Dati';
        let widgetData: any = null;
        if (currentInput.toLowerCase().includes('torta') || currentInput.toLowerCase().includes('pie') || currentInput.toLowerCase().includes('distribuzione')) {
          widgetType = 'chart';
          widgetTitle = 'Distribuzione per Tipologia';
          widgetData = {
            type: 'pie',
            data: propertyTypeData
          };
        } else if (currentInput.toLowerCase().includes('barre') || currentInput.toLowerCase().includes('bar') || currentInput.toLowerCase().includes('confronto')) {
          widgetType = 'chart';
          widgetTitle = 'Performance Mensile';
          widgetData = {
            type: 'bar',
            data: monthlyData
          };
        } else if (currentInput.toLowerCase().includes('linea') || currentInput.toLowerCase().includes('line') || currentInput.toLowerCase().includes('andamento') || currentInput.toLowerCase().includes('trend')) {
          widgetType = 'chart';
          widgetTitle = 'Andamento Trattative';
          widgetData = {
            type: 'line',
            data: monthlyData
          };
        } else if (currentInput.toLowerCase().includes('statistiche') || currentInput.toLowerCase().includes('numeri') || currentInput.toLowerCase().includes('kpi')) {
          widgetType = 'stat';
          widgetTitle = 'Statistiche Chiave';
          widgetData = stats;
        }
        if (widgetData) {
          const newWidget: GeneratedWidget = {
            id: widgetId,
            type: widgetType,
            title: widgetTitle,
            data: widgetData,
            timestamp: new Date()
          };
          setGeneratedWidgets(prev => [...prev, newWidget]);
          newWidgetIds.push(widgetId);
        }
      }
      const assistantMessage: AIMessage = {
        role: 'assistant' as const,
        content: assistantContent,
        widgetIds: newWidgetIds.length > 0 ? newWidgetIds : undefined,
        isDemo: true
      };
      const updatedMessages = [...aiMessages, userMessage, assistantMessage];
      setAiMessages(updatedMessages);
      if (currentChatId) {
        const chatTitle = updatedMessages[0]?.content.slice(0, 50) + '...' || 'Nuova Chat';
        setChatHistory(prev => {
          const existingIndex = prev.findIndex(chat => chat.id === currentChatId);
          const updatedChat: ChatHistory = {
            id: currentChatId,
            title: chatTitle,
            messages: updatedMessages,
            widgets: generatedWidgets,
            timestamp: new Date()
          };
          if (existingIndex >= 0) {
            const newHistory = [...prev];
            newHistory[existingIndex] = updatedChat;
            return newHistory;
          }
          return [updatedChat, ...prev];
        });
      }
    } catch (error) {
      console.error('Error calling AI:', error);
      // Add minimum delay even for errors
      const elapsedTime = Date.now() - Date.now();
      const remainingDelay = Math.max(0, minDelay - elapsedTime);
      if (remainingDelay > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingDelay));
      }
      const errorMessage: AIMessage = {
        role: 'assistant' as const,
        content: 'Mi dispiace, si è verificato un errore. Riprova più tardi.'
      };
      setAiMessages(prev => [...prev, errorMessage]);
    } finally {
      setIsAILoading(false);
    }
  };
  const loadChat = (chat: ChatHistory) => {
    setCurrentChatId(chat.id);
    setAiMessages(chat.messages);
    setGeneratedWidgets(chat.widgets);
    setHasStartedChat(true);
    setIsChatHistoryOpen(false);
  };
  const startNewChat = () => {
    setCurrentChatId(null);
    setAiMessages([]);
    setGeneratedWidgets([]);
    setHasStartedChat(false);
    setIsChatHistoryOpen(false);
  };
  const renderGeneratedWidget = (widget: GeneratedWidget) => {
    if (widget.type === 'chart' && widget.data) {
      if (widget.data.type === 'pie') {
        return <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 lg:p-6" data-id="element-1248">
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-3 sm:mb-4" data-id="element-1249">
              {widget.title}
            </h3>
            <ResponsiveContainer width="100%" height={200} className="sm:!h-[250px]" data-id="element-1250">
              <PieChart data-id="element-1251">
                <Pie data={widget.data.data} cx="50%" cy="50%" labelLine={false} label={({
                name,
                percent
              }) => `${name} ${(percent * 100).toFixed(0)}%`} outerRadius={60} className="sm:!outerRadius-[80]" fill="#8884d8" dataKey="value" data-id="element-1252">
                  {widget.data.data.map((entry: any, index: number) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1253" />)}
                </Pie>
                <Tooltip data-id="element-1254" />
              </PieChart>
            </ResponsiveContainer>
          </div>;
      } else if (widget.data.type === 'bar') {
        return <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 lg:p-6" data-id="element-1255">
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-3 sm:mb-4" data-id="element-1256">
              {widget.title}
            </h3>
            <ResponsiveContainer width="100%" height={200} className="sm:!h-[250px]" data-id="element-1257">
              <BarChart data={widget.data.data} data-id="element-1258">
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1259" />
                <XAxis dataKey="month" tick={{
                fontSize: 10
              }} className="sm:text-xs" stroke="#9ca3af" data-id="element-1260" />
                <YAxis tick={{
                fontSize: 10
              }} className="sm:text-xs" stroke="#9ca3af" data-id="element-1261" />
                <Tooltip data-id="element-1262" />
                <Bar dataKey="deals" fill="#1388ad" name="Trattative" data-id="element-1263" />
              </BarChart>
            </ResponsiveContainer>
          </div>;
      } else if (widget.data.type === 'line') {
        return <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 lg:p-6" data-id="element-1264">
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-3 sm:mb-4" data-id="element-1265">
              {widget.title}
            </h3>
            <ResponsiveContainer width="100%" height={200} className="sm:!h-[250px]" data-id="element-1266">
              <LineChart data={widget.data.data} data-id="element-1267">
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1268" />
                <XAxis dataKey="month" tick={{
                fontSize: 10
              }} className="sm:text-xs" stroke="#9ca3af" data-id="element-1269" />
                <YAxis tick={{
                fontSize: 10
              }} className="sm:text-xs" stroke="#9ca3af" data-id="element-1270" />
                <Tooltip data-id="element-1271" />
                <Legend wrapperStyle={{
                fontSize: '10px'
              }} className="sm:text-xs" data-id="element-1272" />
                <Line type="monotone" dataKey="deals" stroke="#1388ad" strokeWidth={2} name="Trattative" data-id="element-1273" />
                <Line type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={2} name="Revenue" data-id="element-1274" />
              </LineChart>
            </ResponsiveContainer>
          </div>;
      }
    }
    if (widget.type === 'stat' && widget.data) {
      return <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 lg:p-6" data-id="element-1275">
          <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-3 sm:mb-4" data-id="element-1276">
            {widget.title}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-1277">
            {widget.data.slice(0, 4).map((stat: any) => <div key={stat.id} className="p-3 sm:p-4 bg-gray-50 rounded-lg" data-id="element-1278">
                <span className="text-[10px] sm:text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full inline-block mb-2" data-id="element-1279">
                  {stat.change}
                </span>
                <p className="text-xl sm:text-2xl font-semibold text-gray-900" data-id="element-1280">
                  {stat.value}
                </p>
                <p className="text-[10px] sm:text-xs text-gray-500 mt-1" data-id="element-1281">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>;
    }
    return null;
  };
  const renderOverviewContent = () => {
    return <div className="space-y-6" data-id="element-1282">
        {/* KPI Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1283">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={stat.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1284">
                <div className="p-3 border-b border-gray-200 bg-white" data-id="element-1285">
                  <div className="flex items-center gap-2" data-id="element-1286">
                    <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-1287" />
                    <h3 className="text-xs font-semibold text-gray-900" data-id="element-1288">
                      {stat.label}
                    </h3>
                  </div>
                </div>
                <div className="p-4" data-id="element-1289">
                  <div className="flex items-center justify-between mb-2" data-id="element-1290">
                    <p className="text-3xl font-semibold text-gray-900" data-id="element-1291">
                      {stat.value}
                    </p>
                    <span className="text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full" data-id="element-1292">
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Quick Actions and Pipeline */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1293">
          {/* Quick Actions Widget */}
          <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1294">
            <div className="p-4 border-b border-gray-200" data-id="element-1295">
              <div className="flex items-center gap-2" data-id="element-1296">
                <Plus className="w-5 h-5 text-[#1388ad]" data-id="element-1297" />
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1298">
                  Azioni Rapide
                </h3>
              </div>
            </div>
            <div className="p-4" data-id="element-1299">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1300">
                <button className="bg-white border-2 border-dashed border-gray-300 hover:border-[#1388ad] hover:bg-[#1388ad]/5 p-4 rounded-lg transition-all group text-left" data-id="element-1301">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1302">
                    <div className="w-10 h-10 bg-[#1388ad]/10 group-hover:bg-[#1388ad]/20 rounded-lg flex items-center justify-center transition-colors" data-id="element-1303">
                      <Building2 className="w-5 h-5 text-[#1388ad]" data-id="element-1304" />
                    </div>
                  </div>
                  <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1305">
                    Aggiungi Immobile
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1306">
                    Inserisci un nuovo immobile
                  </p>
                </button>
                <button className="bg-white border-2 border-dashed border-gray-300 hover:border-[#1388ad] hover:bg-[#1388ad]/5 p-4 rounded-lg transition-all group text-left" data-id="element-1307">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1308">
                    <div className="w-10 h-10 bg-[#1388ad]/10 group-hover:bg-[#1388ad]/20 rounded-lg flex items-center justify-center transition-colors" data-id="element-1309">
                      <Users className="w-5 h-5 text-[#1388ad]" data-id="element-1310" />
                    </div>
                  </div>
                  <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1311">
                    Aggiungi Brand
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1312">
                    Registra un nuovo brand
                  </p>
                </button>
                <button className="bg-white border-2 border-dashed border-gray-300 hover:border-[#1388ad] hover:bg-[#1388ad]/5 p-4 rounded-lg transition-all group text-left" data-id="element-1313">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1314">
                    <div className="w-10 h-10 bg-[#1388ad]/10 group-hover:bg-[#1388ad]/20 rounded-lg flex items-center justify-center transition-colors" data-id="element-1315">
                      <HandshakeIcon className="w-5 h-5 text-[#1388ad]" data-id="element-1316" />
                    </div>
                  </div>
                  <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1317">
                    Nuova Trattativa
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1318">Avvia una trattativa</p>
                </button>
                <button className="bg-white border-2 border-dashed border-gray-300 hover:border-[#1388ad] hover:bg-[#1388ad]/5 p-4 rounded-lg transition-all group text-left" data-id="element-1319">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1320">
                    <div className="w-10 h-10 bg-[#1388ad]/10 group-hover:bg-[#1388ad]/20 rounded-lg flex items-center justify-center transition-colors" data-id="element-1321">
                      <Calendar className="w-5 h-5 text-[#1388ad]" data-id="element-1322" />
                    </div>
                  </div>
                  <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1323">
                    Crea Evento
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1324">
                    Pianifica un appuntamento
                  </p>
                </button>
              </div>
            </div>
          </div>
          {/* Pipeline Overview */}
          <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1325">
            <div className="p-4 border-b border-gray-200" data-id="element-1326">
              <div className="flex items-center gap-2" data-id="element-1327">
                <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-1328" />
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1329">
                  Pipeline di Vendita
                </h3>
              </div>
            </div>
            <div className="p-4" data-id="element-1330">
              <table className="w-full" data-id="element-1331">
                <thead data-id="element-1332">
                  <tr className="border-b border-gray-200" data-id="element-1333">
                    <th className="text-left text-xs font-semibold text-gray-600 pb-3" data-id="element-1334">
                      Fase
                    </th>
                    <th className="text-right text-xs font-semibold text-gray-600 pb-3" data-id="element-1335">
                      Trattative
                    </th>
                    <th className="text-right text-xs font-semibold text-gray-600 pb-3" data-id="element-1336">
                      Valore
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1337">
                  {pipelinePhases.map((phase, index) => <tr key={index} className="border-b border-gray-100 last:border-0" data-id="element-1338">
                      <td className="py-3" data-id="element-1339">
                        <div className="flex items-center gap-2" data-id="element-1340">
                          <div className="w-2 h-2 rounded-full" style={{
                        backgroundColor: phase.color
                      }} data-id="element-1341" />
                          <span className="text-sm text-gray-900" data-id="element-1342">
                            {phase.phase}
                          </span>
                        </div>
                      </td>
                      <td className="text-right py-3" data-id="element-1343">
                        <span className="text-sm font-semibold text-gray-900" data-id="element-1344">
                          {phase.deals}
                        </span>
                      </td>
                      <td className="text-right py-3" data-id="element-1345">
                        <span className="text-sm font-semibold text-[#1388ad]" data-id="element-1346">
                          €{(phase.value / 1000).toFixed(0)}K
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Charts and Recent Activities */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1347">
          <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1348">
            <div className="p-4 border-b border-gray-200" data-id="element-1349">
              <div className="flex items-center gap-2" data-id="element-1350">
                <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-1351" />
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1352">
                  Andamento Mensile
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-1353">
              <ResponsiveContainer width="100%" height={300} data-id="element-1354">
                <LineChart data={monthlyData} data-id="element-1355">
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1356" />
                  <XAxis dataKey="month" stroke="#9ca3af" data-id="element-1357" />
                  <YAxis stroke="#9ca3af" data-id="element-1358" />
                  <Tooltip data-id="element-1359" />
                  <Legend data-id="element-1360" />
                  <Line type="monotone" dataKey="deals" stroke="#1388ad" strokeWidth={2} name="Trattative" data-id="element-1361" />
                  <Line type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={2} name="Revenue" data-id="element-1362" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1363">
            <div className="p-4 border-b border-gray-200" data-id="element-1364">
              <div className="flex items-center gap-2" data-id="element-1365">
                <Clock className="w-5 h-5 text-[#1388ad]" data-id="element-1366" />
                <h3 className="text-sm font-semibold text-gray-900" data-id="element-1367">
                  Attività Recenti
                </h3>
              </div>
            </div>
            <div className="p-4" data-id="element-1368">
              <div className="space-y-4" data-id="element-1369">
                {recentActivities.map(activity => <div key={activity.id} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-1370">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${activity.status === 'success' ? 'bg-green-100' : 'bg-blue-100'}`} data-id="element-1371">
                      {activity.type === 'deal' && <HandshakeIcon className={`w-4 h-4 ${activity.status === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-1372" />}
                      {activity.type === 'property' && <Building2 className={`w-4 h-4 ${activity.status === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-1373" />}
                      {activity.type === 'email' && <Mail className={`w-4 h-4 ${activity.status === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-1374" />}
                      {activity.type === 'brand' && <Users className={`w-4 h-4 ${activity.status === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-1375" />}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-1376">
                      <p className="text-sm font-normal text-gray-900" data-id="element-1377">
                        {activity.title}
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1378">
                        {activity.description}
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-1379">
                        {activity.time}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>;
  };
  const renderBrandsContent = () => {
    const totalBrands = brandCategoryData.reduce((sum, item) => sum + item.count, 0);
    return <div className="space-y-6" data-id="element-1380">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-1381">
          {statsCategories.brands.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1382">
                <div className="p-3 border-b border-gray-200 bg-white" data-id="element-1383">
                  <div className="flex items-center gap-2" data-id="element-1384">
                    <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-1385" />
                    <h3 className="text-xs font-semibold text-gray-900" data-id="element-1386">
                      {stat.label}
                    </h3>
                  </div>
                </div>
                <div className="p-4" data-id="element-1387">
                  <div className="flex items-center justify-between mb-2" data-id="element-1388">
                    <p className="text-3xl font-semibold text-gray-900" data-id="element-1389">
                      {stat.value}
                    </p>
                    <span className="text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full" data-id="element-1390">
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Brand per Categoria */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1391">
          <div className="p-4 border-b border-gray-200" data-id="element-1392">
            <div className="flex items-center gap-2" data-id="element-1393">
              <BarChart3 className="w-5 h-5 text-[#1388ad]" data-id="element-1394" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-1395">
                Clienti per Categoria
              </h3>
            </div>
          </div>
          <div className="p-6" data-id="element-1396">
            <div className="space-y-4" data-id="element-1397">
              {brandCategoryData.map((brand, index) => {
              const percentage = (brand.count / totalBrands * 100).toFixed(1);
              return <div key={index} className="space-y-2" data-id="element-1398">
                    <div className="flex items-center justify-between" data-id="element-1399">
                      <span className="text-sm font-normal text-gray-900" data-id="element-1400">
                        {brand.category}
                      </span>
                      <div className="flex items-center gap-3" data-id="element-1401">
                        <span className="text-sm font-normal text-gray-600" data-id="element-1402">
                          {brand.count} clienti
                        </span>
                        <span className="text-sm font-semibold text-[#1388ad] min-w-[45px] text-right" data-id="element-1403">
                          {percentage}%
                        </span>
                      </div>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1404">
                      <div className="h-2.5 rounded-full transition-all duration-500" style={{
                    width: `${percentage}%`,
                    backgroundColor: brand.color
                  }} data-id="element-1405" />
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
        {/* Top Brand per Budget */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1406">
          <div className="p-4 border-b border-gray-200" data-id="element-1407">
            <div className="flex items-center gap-2" data-id="element-1408">
              <Target className="w-5 h-5 text-[#1388ad]" data-id="element-1409" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-1410">
                Top 5 Clienti per Budget
              </h3>
            </div>
          </div>
          <div className="p-6" data-id="element-1411">
            <div className="space-y-3" data-id="element-1412">
              {topBrandsByBudget.map((brand, index) => <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1413">
                  <div className="flex items-center gap-4 flex-1" data-id="element-1414">
                    <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1415">
                      <span className="text-sm font-semibold text-[#1388ad]" data-id="element-1416">
                        #{index + 1}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-1417">
                      <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-1418">
                        {brand.name}
                      </p>
                      <div className="flex items-center gap-2 mt-1" data-id="element-1419">
                        <span className="px-2 py-0.5 bg-gray-200 text-gray-700 text-xs rounded-full" data-id="element-1420">
                          {brand.category}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-1421">
                          {brand.location}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right ml-4" data-id="element-1422">
                    <p className="text-lg font-semibold text-[#1388ad]" data-id="element-1423">
                      {brand.budget}
                    </p>
                    <span className="px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-1424">
                      {brand.status}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>;
  };
  const renderImmobiliContent = () => {
    const totalProperties = propertyTypeData.reduce((sum, item) => sum + item.value, 0);
    return <div className="space-y-6" data-id="element-1425">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-1426">
          {statsCategories.immobili.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1427">
                <div className="p-3 border-b border-gray-200 bg-white" data-id="element-1428">
                  <div className="flex items-center gap-2" data-id="element-1429">
                    <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-1430" />
                    <h3 className="text-xs font-semibold text-gray-900" data-id="element-1431">
                      {stat.label}
                    </h3>
                  </div>
                </div>
                <div className="p-4" data-id="element-1432">
                  <div className="flex items-center justify-between mb-2" data-id="element-1433">
                    <p className="text-3xl font-semibold text-gray-900" data-id="element-1434">
                      {stat.value}
                    </p>
                    <span className="text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full" data-id="element-1435">
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1436">
          <div className="p-4 border-b border-gray-200" data-id="element-1437">
            <div className="flex items-center gap-2" data-id="element-1438">
              <LayoutGrid className="w-5 h-5 text-[#1388ad]" data-id="element-1439" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-1440">
                Distribuzione per Tipologia
              </h3>
            </div>
          </div>
          <div className="p-6" data-id="element-1441">
            <div className="space-y-4" data-id="element-1442">
              {propertyTypeData.map((property, index) => {
              const percentage = (property.value / totalProperties * 100).toFixed(1);
              return <div key={index} className="space-y-2" data-id="element-1443">
                    <div className="flex items-center justify-between" data-id="element-1444">
                      <span className="text-sm font-normal text-gray-900" data-id="element-1445">
                        {property.name}
                      </span>
                      <div className="flex items-center gap-3" data-id="element-1446">
                        <span className="text-sm font-normal text-gray-600" data-id="element-1447">
                          {property.value} immobili
                        </span>
                        <span className="text-sm font-semibold text-[#1388ad] min-w-[45px] text-right" data-id="element-1448">
                          {percentage}%
                        </span>
                      </div>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1449">
                      <div className="h-2.5 rounded-full transition-all duration-500" style={{
                    width: `${percentage}%`,
                    backgroundColor: property.color
                  }} data-id="element-1450" />
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>;
  };
  const dealTypeFilterOptions = [{
    value: 'all' as const,
    label: 'Tutte le Tipologie',
    icon: null,
    color: '#374151'
  }, {
    value: 'retail' as const,
    label: 'Retail',
    icon: Store,
    color: '#1388ad'
  }, {
    value: 'investment' as const,
    label: 'Investment',
    icon: TrendingUp,
    color: '#6bb2cd'
  }];
  const selectedDealTypeOption = dealTypeFilterOptions.find(opt => opt.value === dealTypeFilter);
  const renderTrattativeContent = () => {
    const totalDeals = 23;
    const retailDeals = 15;
    const investmentDeals = 8;
    const retailPercentage = Math.round(retailDeals / totalDeals * 100);
    const investmentPercentage = Math.round(investmentDeals / totalDeals * 100);
    const getChartData = () => {
      if (dealTypeFilter === 'retail') {
        return monthlyData.map(item => ({
          month: item.month,
          deals: item.dealsRetail
        }));
      } else if (dealTypeFilter === 'investment') {
        return monthlyData.map(item => ({
          month: item.month,
          deals: item.dealsInvestment
        }));
      } else {
        return monthlyData.map(item => ({
          month: item.month,
          retail: item.dealsRetail,
          investment: item.dealsInvestment
        }));
      }
    };
    const chartData = getChartData();
    // Only 4 main KPIs
    const mainKPIs = [{
      icon: HandshakeIcon,
      label: 'Trattative Totali',
      value: '23',
      change: '+15%',
      trend: 'up'
    }, {
      icon: Euro,
      label: 'Revenue Totale',
      value: '€1.89M',
      change: '+18%',
      trend: 'up'
    }, {
      icon: TrendingUp,
      label: 'Tasso Conversione',
      value: '34%',
      change: '+5%',
      trend: 'up'
    }, {
      icon: Target,
      label: 'Valore Medio',
      value: '€82K',
      change: '+8%',
      trend: 'up'
    }];
    return <div className="space-y-6" data-id="element-1451">
        {/* KPI Cards - Only 4 main ones */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1452">
          {mainKPIs.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1453">
                <div className="p-3 border-b border-gray-200 bg-white" data-id="element-1454">
                  <div className="flex items-center gap-2" data-id="element-1455">
                    <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-1456" />
                    <h3 className="text-xs font-semibold text-gray-900" data-id="element-1457">
                      {stat.label}
                    </h3>
                  </div>
                </div>
                <div className="p-4" data-id="element-1458">
                  <div className="flex items-center justify-between mb-2" data-id="element-1459">
                    <p className="text-3xl font-semibold text-gray-900" data-id="element-1460">
                      {stat.value}
                    </p>
                    <span className="text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full" data-id="element-1461">
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Split Indicator */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1462">
          <div className="p-4 border-b border-gray-200 bg-white" data-id="element-1463">
            <h3 className="text-sm font-semibold text-gray-900" data-id="element-1464">
              Distribuzione per Tipologia
            </h3>
          </div>
          <div className="p-6" data-id="element-1465">
            <div className="flex items-center justify-between mb-4" data-id="element-1466">
              <div className="flex items-center gap-4 text-sm" data-id="element-1467">
                <div className="flex items-center gap-2" data-id="element-1468">
                  <div className="w-3 h-3 bg-[#1388ad] rounded-full" data-id="element-1469" />
                  <span className="text-gray-600" data-id="element-1470">Retail</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1471">
                  <div className="w-3 h-3 bg-[#6bb2cd] rounded-full" data-id="element-1472" />
                  <span className="text-gray-600" data-id="element-1473">Investment</span>
                </div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-1474">
              <div className="relative h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-1475">
                <div className="absolute left-0 top-0 h-full bg-[#1388ad] transition-all duration-500" style={{
                width: `${retailPercentage}%`
              }} data-id="element-1476" />
                <div className="absolute right-0 top-0 h-full bg-[#6bb2cd] transition-all duration-500" style={{
                width: `${investmentPercentage}%`
              }} data-id="element-1477" />
              </div>
              <div className="flex items-center justify-between text-sm" data-id="element-1478">
                <span className="font-semibold text-[#1388ad]" data-id="element-1479">
                  {retailPercentage}% Retail ({retailDeals} trattative)
                </span>
                <span className="font-semibold text-[#6bb2cd]" data-id="element-1480">
                  {investmentPercentage}% Investment ({investmentDeals}{' '}
                  trattative)
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Chart with Toggle */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-1481">
          <div className="p-4 border-b border-gray-200 bg-white flex items-center justify-between" data-id="element-1482">
            <div className="flex items-center gap-2" data-id="element-1483">
              <HandshakeIcon className="w-5 h-5 text-[#1388ad]" data-id="element-1484" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-1485">
                Andamento Trattative
              </h3>
            </div>
            <div className="relative" ref={trattativeFilterRef} data-id="element-1486">
              <button onClick={() => setIsTrattativeFilterOpen(!isTrattativeFilterOpen)} className="px-4 py-2 bg-gray-100 text-gray-900 text-sm font-normal rounded-full border border-gray-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[#1388ad] transition-colors flex items-center gap-2 min-w-[180px]" data-id="element-1487">
                {selectedDealTypeOption?.icon && <selectedDealTypeOption.icon className="w-4 h-4 flex-shrink-0" data-id="element-1488" />}
                <span className="flex-1 text-left whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-1489">
                  {selectedDealTypeOption?.label}
                </span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isTrattativeFilterOpen ? 'rotate-180' : ''}`} data-id="element-1490" />
              </button>
              {isTrattativeFilterOpen && <div className="absolute top-full right-0 mt-2 w-full min-w-[180px] bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-xl z-50" data-id="element-1491">
                  {dealTypeFilterOptions.map(option => {
                const OptionIcon = option.icon;
                const isSelected = dealTypeFilter === option.value;
                return <button key={option.value} onClick={() => {
                  setDealTypeFilter(option.value);
                  setIsTrattativeFilterOpen(false);
                }} className="w-full px-4 py-3 text-left text-sm flex items-center gap-2 transition-colors whitespace-nowrap" style={isSelected ? {
                  backgroundColor: option.color,
                  color: 'white'
                } : undefined} data-id="element-1492">
                        {OptionIcon && <OptionIcon className="w-4 h-4 flex-shrink-0" data-id="element-1493" />}
                        <span data-id="element-1494">{option.label}</span>
                      </button>;
              })}
                </div>}
            </div>
          </div>
          <div className="p-6" data-id="element-1495">
            <ResponsiveContainer width="100%" height={400} data-id="element-1496">
              {dealTypeFilter === 'all' ? <BarChart data={chartData} data-id="element-1497">
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1498" />
                  <XAxis dataKey="month" stroke="#9ca3af" data-id="element-1499" />
                  <YAxis stroke="#9ca3af" data-id="element-1500" />
                  <Tooltip data-id="element-1501" />
                  <Legend data-id="element-1502" />
                  <Bar dataKey="retail" fill="#1388ad" name="Retail" data-id="element-1503" />
                  <Bar dataKey="investment" fill="#6bb2cd" name="Investment" data-id="element-1504" />
                </BarChart> : <BarChart data={chartData} data-id="element-1505">
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1506" />
                  <XAxis dataKey="month" stroke="#9ca3af" data-id="element-1507" />
                  <YAxis stroke="#9ca3af" data-id="element-1508" />
                  <Tooltip data-id="element-1509" />
                  <Legend data-id="element-1510" />
                  <Bar dataKey="deals" fill={dealTypeFilter === 'retail' ? '#1388ad' : '#6bb2cd'} name={dealTypeFilter === 'retail' ? 'Retail' : 'Investment'} data-id="element-1511" />
                </BarChart>}
            </ResponsiveContainer>
          </div>
        </div>
      </div>;
  };
  if (isAIMode) {
    return <>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-gray-50 z-50 flex flex-col" data-id="element-1512">
          {/* AI Mode Header */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="px-4 sm:px-6 py-4 flex-shrink-0 border-b border-gray-200 bg-white" data-id="element-1513">
            <div className="flex items-center justify-between" data-id="element-1514">
              <div className="flex items-center gap-3" data-id="element-1515">
                <button onClick={() => setIsChatHistoryOpen(!isChatHistoryOpen)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1516">
                  <Menu className="w-5 h-5 text-gray-600" data-id="element-1517" />
                </button>
                <div className="w-10 h-10 bg-[#1388ad] rounded-full flex items-center justify-center" data-id="element-1518">
                  <Sparkles className="w-5 h-5 text-white" data-id="element-1519" />
                </div>
                <div data-id="element-1520">
                  <h1 className="text-lg sm:text-xl font-semibold text-gray-900" data-id="element-1521">
                    EDA Intelligence
                  </h1>
                  <p className="text-xs sm:text-sm text-gray-500" data-id="element-1522">
                    Analisi e visualizzazioni intelligenti
                  </p>
                </div>
              </div>
              <button onClick={() => {
              setIsAIMode(false);
              setHasStartedChat(false);
              setAiMessages([]);
              setGeneratedWidgets([]);
              setCurrentChatId(null);
            }} className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-sm font-normal transition-colors" data-id="element-1523">
                <X className="w-4 h-4" data-id="element-1524" />
                <span className="hidden sm:inline" data-id="element-1525">Esci</span>
              </button>
            </div>
          </motion.div>
          {/* Chat History Sidebar */}
          <AnimatePresence data-id="element-1526">
            {isChatHistoryOpen && <>
                <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} onClick={() => setIsChatHistoryOpen(false)} className="fixed inset-0 bg-black/20 z-40" data-id="element-1527" />
                <motion.div initial={{
              x: -300
            }} animate={{
              x: 0
            }} exit={{
              x: -300
            }} transition={{
              type: 'spring',
              damping: 25
            }} className="fixed left-0 top-0 bottom-0 w-80 bg-white border-r border-gray-200 z-50 flex flex-col" data-id="element-1528">
                  <div className="p-4 border-b border-gray-200" data-id="element-1529">
                    <div className="flex items-center justify-between mb-4" data-id="element-1530">
                      <h2 className="text-lg font-semibold text-gray-900" data-id="element-1531">
                        Storico Chat
                      </h2>
                      <button onClick={() => setIsChatHistoryOpen(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1532">
                        <X className="w-5 h-5 text-gray-600" data-id="element-1533" />
                      </button>
                    </div>
                    <button onClick={startNewChat} className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors" data-id="element-1534">
                      <Plus className="w-4 h-4" data-id="element-1535" />
                      Nuova Chat
                    </button>
                  </div>
                  <div className="flex-1 overflow-y-auto p-4 space-y-2" data-id="element-1536">
                    {chatHistory.length === 0 ? <div className="text-center py-8" data-id="element-1537">
                        <p className="text-sm text-gray-500" data-id="element-1538">
                          Nessuna chat salvata
                        </p>
                      </div> : chatHistory.map(chat => <button key={chat.id} onClick={() => loadChat(chat)} className={`w-full text-left p-3 rounded-lg transition-colors ${currentChatId === chat.id ? 'bg-[#1388ad]/10 border border-[#1388ad]' : 'hover:bg-gray-50 border border-transparent'}`} data-id="element-1539">
                          <p className="text-sm font-medium text-gray-900 truncate mb-1" data-id="element-1540">
                            {chat.title}
                          </p>
                          <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-1541">
                            <Calendar className="w-3 h-3" data-id="element-1542" />
                            <span data-id="element-1543">
                              {new Date(chat.timestamp).toLocaleDateString('it-IT', {
                        day: '2-digit',
                        month: 'short',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                            </span>
                            <span className="ml-auto" data-id="element-1544">
                              {chat.messages.length} messaggi
                            </span>
                          </div>
                        </button>)}
                  </div>
                </motion.div>
              </>}
          </AnimatePresence>
          {/* AI Mode Content */}
          {!hasStartedChat ? <div className="flex-1 flex items-center justify-center p-4 sm:p-6" data-id="element-1545">
              <div className="w-full max-w-3xl" data-id="element-1546">
                {/* Welcome Message */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="text-center mb-8 sm:mb-12" data-id="element-1547">
                  <motion.div initial={{
                scale: 0.8,
                opacity: 0
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                duration: 0.5,
                delay: 0.3,
                type: 'spring'
              }} className="w-16 h-16 sm:w-20 sm:h-20 bg-[#1388ad]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6" data-id="element-1548">
                    <Sparkles className="w-8 h-8 sm:w-10 sm:h-10 text-[#1388ad]" data-id="element-1549" />
                  </motion.div>
                  <motion.h2 initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.4,
                delay: 0.4
              }} className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-3" data-id="element-1550">
                    Come posso aiutarti oggi?
                  </motion.h2>
                  <motion.p initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                duration: 0.4,
                delay: 0.5
              }} className="text-sm sm:text-base text-gray-500" data-id="element-1551">
                    Chiedi analisi, visualizzazioni o suggerimenti strategici
                  </motion.p>
                </motion.div>
                {/* Centered Input */}
                <motion.form initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.6
            }} onSubmit={handleAISubmit} className="mb-8 sm:mb-12" data-id="element-1552">
                  <div className="relative" data-id="element-1553">
                    <input type="text" value={aiInput} onChange={e => setAiInput(e.target.value)} placeholder="Fai una richiesta a EDA Intelligence..." disabled={isAILoading} className="w-full px-4 py-3 pr-12 text-base border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#1388ad] focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500 transition-all" autoFocus data-id="element-1554" />
                    <button type="submit" disabled={isAILoading || !aiInput.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-[#1388ad] text-white rounded-full hover:bg-[#0f6b8a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1555">
                      <Send className="w-4 h-4" data-id="element-1556" />
                    </button>
                  </div>
                </motion.form>
                {/* Example Prompts */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.7
            }} className="space-y-3" data-id="element-1557">
                  <p className="text-sm font-medium text-gray-700 mb-4" data-id="element-1558">
                    Prova questi esempi:
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1559">
                    {[{
                  icon: TrendingUp,
                  text: "Mostrami l'andamento delle trattative negli ultimi mesi",
                  delay: 0.8
                }, {
                  icon: TrendingUp,
                  text: 'Come posso migliorare il tasso di conversione?',
                  delay: 0.85
                }, {
                  icon: Mail,
                  text: 'Analizza le performance delle campagne email',
                  delay: 0.9
                }, {
                  icon: FileText,
                  text: 'Genera un report sulle performance dei collaboratori',
                  delay: 0.95
                }].map((example, index) => {
                  const Icon = example.icon;
                  return <motion.button key={index} initial={{
                    opacity: 0,
                    y: 20
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    duration: 0.4,
                    delay: example.delay
                  }} onClick={() => setAiInput(example.text)} className="p-4 bg-white border border-gray-200 rounded-lg hover:border-[#1388ad] hover:bg-gray-50 transition-all text-left group" data-id="element-1560">
                          <div className="flex items-start gap-3" data-id="element-1561">
                            <div className="w-8 h-8 bg-[#1388ad]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1562">
                              <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-1563" />
                            </div>
                            <p className="text-sm text-gray-700" data-id="element-1564">
                              {example.text}
                            </p>
                          </div>
                        </motion.button>;
                })}
                  </div>
                </motion.div>
              </div>
            </div> : <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3
        }} className="flex-1 flex flex-col overflow-hidden" data-id="element-1565">
              {/* Messages Area */}
              <div className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-6 min-h-0" data-id="element-1566">
                <div className="max-w-4xl mx-auto w-full space-y-6" data-id="element-1567">
                  <AnimatePresence mode="popLayout" data-id="element-1568">
                    {aiMessages.map((message, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -20
                }} transition={{
                  duration: 0.3
                }} data-id="element-1569">
                        <div className={`flex gap-3 ${message.role === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-1570">
                          {/* Assistant Avatar */}
                          {message.role === 'assistant' && <div className="w-8 h-8 bg-[#1388ad] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1571">
                              <Sparkles className="w-4 h-4 text-white" data-id="element-1572" />
                            </div>}
                          <div className="max-w-[85%] space-y-2" data-id="element-1573">
                            {message.role === 'assistant' && message.isDemo && <div className="flex items-center gap-2" data-id="element-1574">
                                <span className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200" data-id="element-1575">
                                  Dati Demo
                                </span>
                              </div>}
                            <div className={`rounded-lg p-4 ${message.role === 'user' ? 'bg-[#1388ad] text-white' : 'bg-white border border-gray-200 text-gray-900'}`} data-id="element-1576">
                              {message.role === 'assistant' ? <div className="text-sm sm:text-base prose prose-sm max-w-none" dangerouslySetInnerHTML={{
                          __html: message.content
                        }} style={{
                          lineHeight: '1.6'
                        }} data-id="element-1577" /> : <p className="text-sm sm:text-base whitespace-pre-wrap break-words leading-relaxed" data-id="element-1578">
                                  {message.content}
                                </p>}
                            </div>
                            {/* Add Report Button if this is a report response */}
                            {message.role === 'assistant' && currentReport && index === aiMessages.length - 1 && <motion.button initial={{
                        opacity: 0,
                        y: 10
                      }} animate={{
                        opacity: 1,
                        y: 0
                      }} transition={{
                        duration: 0.3,
                        delay: 0.2
                      }} onClick={() => setShowReportPreview(true)} className="flex items-center gap-2 px-4 py-3 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors shadow-md hover:shadow-lg w-full justify-center" data-id="element-1579">
                                  <Eye className="w-5 h-5" data-id="element-1580" />
                                  <span className="font-medium" data-id="element-1581">
                                    Visualizza Report
                                  </span>
                                </motion.button>}
                          </div>
                          {/* User Avatar */}
                          {message.role === 'user' && <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png" alt="User Profile" className="w-8 h-8 rounded-full object-cover flex-shrink-0 mt-1" data-id="element-1582" />}
                        </div>
                        {/* Generated Widgets */}
                        {message.widgetIds && message.widgetIds.length > 0 && <motion.div initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    duration: 0.3,
                    delay: 0.1
                  }} className="mt-4 space-y-4" data-id="element-1583">
                            {message.widgetIds.map(widgetId => {
                      const widget = generatedWidgets.find(w => w.id === widgetId);
                      if (!widget) return null;
                      return <div key={widgetId} data-id="element-1584">
                                  {renderGeneratedWidget(widget)}
                                </div>;
                    })}
                          </motion.div>}
                      </motion.div>)}
                  </AnimatePresence>
                  {isAILoading && <motion.div initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} className="flex justify-start" data-id="element-1585">
                      <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1586">
                        <Loader2 className="w-5 h-5 text-gray-600 animate-spin" data-id="element-1587" />
                      </div>
                    </motion.div>}
                </div>
              </div>
              {/* Input Area - Bottom */}
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.1
          }} className="p-4 sm:p-6 flex-shrink-0" data-id="element-1588">
                <div className="max-w-4xl mx-auto w-full" data-id="element-1589">
                  <form onSubmit={handleAISubmit} className="relative" data-id="element-1590">
                    <input type="text" value={aiInput} onChange={e => setAiInput(e.target.value)} placeholder="Fai una richiesta..." disabled={isAILoading} className="w-full px-4 py-3 pr-12 text-base bg-white border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#1388ad] focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500 transition-all" data-id="element-1591" />
                    <button type="submit" disabled={isAILoading || !aiInput.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-[#1388ad] text-white rounded-full hover:bg-[#0f6b8a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1592">
                      <Send className="w-4 h-4" data-id="element-1593" />
                    </button>
                  </form>
                </div>
              </motion.div>
            </motion.div>}
        </motion.div>
        {/* Report Preview Modal - NOW INSIDE isAIMode */}
        {showReportPreview && currentReport && <ReportPreview data={currentReport} onClose={() => {
        setShowReportPreview(false);
        setCurrentReport(null);
      }} data-id="element-1594" />}
      </>;
  }
  return <div className="space-y-6" data-id="element-1595">
      <div className="flex items-center justify-between" data-id="element-1596">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1597">Dashboard</h1>
        <div className="relative" data-id="element-1598">
          <button onClick={() => setIsAIMode(!isAIMode)} className="relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-normal transition-all bg-white border-2 border-[#1388ad] text-[#1388ad] hover:bg-[#1388ad]/5" data-id="element-1599">
            <Sparkles className="w-4 h-4" data-id="element-1600" />
            EDA Intelligence
          </button>
        </div>
      </div>
      {!isAIMode && <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1601">
          <div className="border-b border-gray-200" data-id="element-1602">
            <div className="flex overflow-x-auto" data-id="element-1603">
              {tabs.map(tab => {
            const Icon = tab.icon;
            return <button key={tab.id} onClick={() => {
              setActiveTab(tab.id);
              setIsAIMode(false);
            }} className={`flex items-center gap-2 px-6 py-4 text-sm font-normal whitespace-nowrap transition-colors border-b-2 ${activeTab === tab.id ? 'border-[#1388ad] text-[#1388ad] bg-[#1388ad]/5' : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-1604">
                    <Icon className="w-4 h-4" data-id="element-1605" />
                    {tab.label}
                  </button>;
          })}
            </div>
          </div>
        </div>}
      {!isAIMode && <div className="bg-white border border-gray-200 px-4 sm:px-6 py-3 rounded-lg" data-id="element-1606">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1607">
            <Calendar className="w-4 h-4" data-id="element-1608" />
            <span data-id="element-1609">{dateRange}</span>
            <ChevronDown className="w-4 h-4" data-id="element-1610" />
          </button>
        </div>}
      {!isAIMode && <>
          {activeTab === 'overview' && renderOverviewContent()}
          {activeTab === 'brands' && renderBrandsContent()}
          {activeTab === 'immobili' && renderImmobiliContent()}
          {activeTab === 'trattative' && renderTrattativeContent()}
        </>}
    </div>;
}